
import { defineComponent, reactive, toRefs, onMounted, ref } from "vue";
import {
  httpChannelAdd,
  httpChannelCommissionMerchantList,
  httpChannelList,
  httpChannelSelectList,
} from "@/api/DistributionManagement/ChannelManagement";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage, ElMessageBox } from "element-plus";
import fTime from "@/utils/fTime"; //时间转换
import router from "@/router/index";
export default defineComponent({
  name: "examine",
  setup() {
    let data = reactive<any>({
      // 头部查询
      formList: [
        {
          label: "分销渠道",
          type: "select",
          placeholder: "请选择分销渠道",
          key: "channelId",
          name: "valueName",
          clearable: true,
          optionList: [],
        },
      ],
      //弹框标题
      dialogTit: "添加渠道",
      // 分销渠道列表下拉框请求
      getSelection: () => {
        httpChannelSelectList().then((res) => {
          if (res.code == 1) {
            data.formList[0].optionList = res.data.map((v: any) => {
              return { label: v.channelName, value: v.id };
            });
          }
        });
      },
      // 查询
      submitForm: (val: any) => {
        data.MyTable.tableloading = true;
        data.MyTable.selectData.channelId = val.value.channelId;
        data.getTableData();
        ElMessage({
          type: "success",
          message: "查询成功！",
        });
        data.MyTable.tableloading = false;
      },
      // 添加渠道开关
      addChannel: false,
      //添加渠道点击事件
      addDialog: (msg = {}) => {
        if (Object.keys(msg).length) {
          //判断对象是否为空
          data.dialogTit = "编辑渠道";
          data.addForm = { ...msg };
        } else {
          data.dialogTit = "添加渠道";
          data.addForm = reactive({
            channelName: "",
            channelContactName: "",
            channelMobile: "",
          });
        }
        data.addChannel = true;
      },
      addFormRef: ref<FormInstance>(),
      // 添加信息
      addForm: reactive({
        channelName: "",
        channelContactName: "",
        channelMobile: "",
      }),
      formSize: ref("default"),
      rules: reactive<FormRules>({
        //表单验证规则
        channelName: [
          { required: true, message: "请输入渠道名称", trigger: "blur" },
          { min: 1, max: 20, message: "最多只能输入20字", trigger: "blur" },
        ],
        channelContactName: [
          { required: true, message: "请输入负责人的名字", trigger: "blur" },
          { min: 1, max: 10, message: "请输入负责人的名字", trigger: "blur" },
        ],
        channelMobile: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的电话号码", trigger: "blur", pattern: /^1[3456789]\d{9}$/ },
        ],
      }),
      addSubmit: async (formEl: FormInstance | undefined) => {
        if (!formEl) return;
        await formEl.validate((valid: any, fields: any) => {
          if (valid) {
            //如果表单验证成功，就获取表单数据
            ElMessageBox.confirm("是否确认" + data.dialogTit, {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                httpChannelAdd(data.addForm).then((res) => {
                  if (res.code) {
                    data.addChannel = false;
                    ElMessage({
                      type: "success",
                      message: "添加成功！",
                    });
                    data.getTableData();
                    data.getSelection();
                  }
                });
              })
              .catch(() => {});
          }
        });
      },
      //MyTable组件相关数据
      MyTable: {
        tableloading: false,
        //表格数据
        tableData: [
          // 	"adminId": 添加人id,
          // 	"channelContactName": 渠道联系人,
          // 	"channelMobile": 联系电话,
          // 	"channelName": 渠道名称,
          // 	"createTime": 创建时间,
          // 	"id": 0,
          // 	"merchantNum": 分销商户数量,
          // 	"updateTime": 更新时间
        ],
        selectData: {
          //请求参数
          pageNum: 1,
          pageSize: 5,
        },
        // 表头数据
        tableColumn: [
          {
            prop: "channelName",
            label: "渠道名称",
          },
          {
            prop: "channelContactName",
            label: "渠道负责人",
          },
          {
            prop: "channelMobile",
            label: "联系电话",
          },
          {
            slotName: "merchantNum",
          },
          {
            prop: "createTime",
            label: "创建时间",
          },
          {
            slotName: "slotName",
          },
        ],
        //表格数据
        TotalPageTable: 0,
      },
      // 向后台请求表格数据
      getTableData: () => {
        data.MyTable.tableloading = true;
        httpChannelList(data.MyTable.selectData).then((res) => {
          data.MyTable.tableData = res.data.list.map((v: any) => {
            v.createTime = fTime(v.createTime);
            return v;
          });
          data.MyTable.TotalPageTable = res.data.total;
          data.MyTable.tableloading = false;
        });
      },
      // 表格翻页
      handleMyTable: (val: any) => {
        data.MyTable.selectData.pageNum = val;
        data.getTableData();
      },
      // 查看分销商户表格
      seeTable: {
        tableloading: false,
        tableData: [], //表格数据
        selectData: {
          pageNum: 1, //当前页码
          pageSize: 5, //当前页显示条数
          channelId: 0,
          merchantName: "",
        },
        // 表头数据
        tableColumn: [
          {
            prop: "channelName",
            label: "渠道名称",
          },
          {
            prop: "merchantName",
            label: "连锁商户",
          },
          {
            prop: "createTime",
            label: "分佣创建时间",
          },
          {
            slotName: "cardNum",
          },
        ],
        // 查看分销商户表格翻页
        seeHandleCurrentChange: (val: any) => {
          data.seeTable.selectData.pageNum = val;
          data.getTableData();
        },
        // 查看分销商户开关
        seeChannel: false,
        // 查看分销商户点击事件
        seeDialog: (msg: any) => {
          data.seeTable.selectData.channelId = msg.id;
          httpChannelCommissionMerchantList(data.seeTable.selectData).then((res) => {
            console.log(res);
            data.seeTable.tableData = res.data.list.map((v: any) => {
              v.createTime = fTime(v.createTime);
              return v;
            });
            data.seeTable.TotalPageTable = res.data.total;
            data.seeTable.tableloading = false;
          });
          data.seeTable.seeChannel = true;
        },
      },
      // 跳转分销订单页面并搜索
      routerOrder: (v: any) => {
        router.push({ path: "/DistributionManagement/DistributionOrders", query: { channelId: v.channelId } });
      },
    });
    onMounted(() => {
      data.getTableData();
      data.getSelection();
    });

    return {
      ...toRefs(data),
    };
  },
});
